import React from 'react'
import { formatCurrency } from '../../utils/currencyUtils'

function WorkOrderFooterSection({ subtotal = 0, discount = 0, taxes = 0, total = 0, currency = '₹' }) {
  const formattedSubtotal = formatCurrency(subtotal, currency)
  const formattedDiscount = formatCurrency(discount, currency)
  const formattedTaxes = formatCurrency(taxes, currency)
  const formattedTotal = formatCurrency(total, currency)

  return (
    <div className="quotation-footer">
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        <div>
          <strong>Subtotal:</strong> {formattedSubtotal}
        </div>
        <div>
          <strong>Discount:</strong> -{formattedDiscount}
        </div>
        <div>
          <strong>Taxes:</strong> {formattedTaxes}
        </div>
        <div className="total">
          <strong>Grand Total:</strong> {formattedTotal}
        </div>
      </div>
    </div>
  )
}

export default WorkOrderFooterSection
